import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Controller, useController, useForm, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addHospital } from 'slices/hospitalSlice';
import { hospitalSelector } from 'slices/hospitalSlice';
import ErrorMessage from 'components/common/ErrorMessage';
import { setError } from 'slices/hospitalSlice';
import toast from 'react-hot-toast';
import { updateHospital } from 'slices/hospitalSlice';
import { fetchHospitals } from 'slices/hospitalSlice';
import { Spinner } from 'reactstrap';
import Api from "services/api"
import { fetchCitys } from 'slices/citySlice';
import { fetchStates } from 'slices/stateSlice';
import { stateSelector } from 'slices/stateSlice';
import { citySelector } from 'slices/citySlice';
import { Select } from 'components/common/Select';
import { IconButton, Step, StepLabel, Stepper, Switch } from '@mui/material';
import moment from 'moment';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import { accountsSelector } from 'slices/accountSlice';
import { fetchTypes } from 'slices/typeSlice';
import { fetchLanguages } from 'slices/languageSlice';
import { fetchFacilities } from 'slices/facilitiesSlice';
import { fetchDepartments } from 'slices/departmentSlice';
import { languageSelector } from 'slices/languageSlice';
import { departmentsSelector } from 'slices/departmentSlice';
import { facilitiesSelector } from 'slices/facilitiesSlice';
import PhoneInput from 'components/common/PhoneInput';
import { fetchSubClients } from 'slices/accountSlice';
import { updateAppointment } from 'slices/appointmentSlice';
import { addAppointment } from 'slices/appointmentSlice';
import { fetchAppointments } from 'slices/appointmentSlice';
import { fetchAccounts } from 'slices/accountSlice';
import Card6 from './ConfirmDataStep';
import { setSuccessMessage } from 'slices/appSlice';
import Swal from 'sweetalert2'

const DEFAULT_APPOINTMENT_TYPE = "In Person";
const apiService = new Api();
const appointmentTypes = [
  {
    label: "In Person",
    value: "In Person"
  },
  {
    label: "Video Remote Interpretation",
    value: "Video Remote Interpretation"
  },
  {
    label: "OTP Pre Schedule",
    value: "OTP Pre Schedule"
  },
  {
    label: "OPI On Demand",
    value: "OPI On Demand"
  }

]
const Card1 = ({ control, errors, item }) => {

  const { accounts } = useSelector(accountsSelector);
  const methods = useController({
    control,
    name: "subclient_id",
    rules: { required: true },


  });

  const { onChange } = methods.field;

  const filteredAccounts = React.useMemo(() =>
    accounts?.map(acc => {
      const object = {
        value: acc.id,
        label: acc.name
      }
      return object
    }), [accounts]);


  return (
    <>
      <div className='step_cards step_1'>
        <h2>Select a Client</h2>

        <div className="row-primary">
          <h2>Client <span style={{ color: 'red' }}>*</span></h2>
          <Controller
            name="subclient_id"
            control={control}
            rules={{
              required: "Please select a client"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="subclient_id"
                  options={filteredAccounts || []}
                  {...field}
                  value={field.value ? filteredAccounts?.find((opt) => field.value == opt.value) : ""}
                />
                {
                  errors?.subclient_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.subclient_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>
      </div>
    </>
  )
}

const Card2 = ({ control }) => {
  // Switch work 
  const methods = useController({
    control,
    name: "type",
    rules: { required: true },
    // defaultValue: DEFAULT_APPOINTMENT_TYPE
  });

  const { setValue } = methods;

  // Switch work 

  return (
    <>
      <div className='step_cards step_2'>
        <h2>Appointment Type</h2>

        <div className='w-100 ps-3'>
          {/* <div className="row-primary">
            <h2 >Appointment Type <span style={{ color: 'red' }}>*</span></h2>
          </div> */}

          <Controller
            name="type"
            control={control}
            render={({ field }) => {
              return appointmentTypes?.map(type => (
                <div className="row-primary align-items-center flex-row">
                  <Switch checked={type.value === field.value} onChange={() => field.onChange(type.value)} />
                  <label htmlFor={type.value} onClick={() => field.onChange(type.value)} style={{ cursor: 'pointer' }} >
                    {type.label}
                  </label>
                </div>
              ))
            }
            }
          />
        </div>
      </div>
    </>
  )
}

const Card3 = ({ control, errors }) => {
  const methods = useController({
    control,
    name: "datetime",
    rules: { required: "Date and time is required" },
    defaultValue: moment().format('YYYY-MM-DD HH:mm:ss'),



  });

  const { setValue } = methods;


  return (
    <>
      <div className='step_cards step_3'>
        <h2>Date & Time *</h2>

        <div className='w-100'>
          <div className="row-primary">
            {/* <h2>Date & Time <span style={{ color: 'red' }}>*</span></h2> */}
            <Controller
              name="datetime"
              control={control}
              rules={{
                required: "Date and time is required"
              }}
              render={({ field }) =>
                <div style={{ width: "100%" }}>
                  <div className="input-image">
                    <input id='date' type="datetime-local" name='datetime' placeholder='Start Date' required
                      {...field}
                      value={field.value}
                      onChange={(e) => {
                        const dateString = moment((e.target.value)).format('YYYY-MM-DD HH:mm:ss');
                        field.onChange(dateString)
                      }}
                    />
                    <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                  </div>

                  {
                    errors?.datetime?.message &&
                    <div style={{ marginBottom: 10 }}>
                      <ErrorMessage text={errors?.datetime?.message} />
                    </div>
                  }


                </div>

              } />

          </div>

          {/* <div className="row-primary">
            <h2>Time <span style={{ color: 'red' }}>*</span></h2>
            <Controller
              name="time"
              control={control}
              render={({ field }) =>
                <div className="input-image">
                  <input id='time' type="time" name='time' placeholder='Start Date' required
                    {...field}
                    value={moment(field.value).format('HH:mm')}
                    onChange={(e) => {
                      const dateString = moment(new Date(e.target.value)).format('YYYY/MM/DD')
                      field.onChange(dateString)
                    }}
                  />
                  <img src="/images/clock.png" alt="celender Icon" className="custom-icon" />

                </div>
              } />

          </div> */}
        </div>
      </div>
    </>
  )
}

const Card4 = ({ control, errors }) => {


  const { language: languages } = useSelector(languageSelector);
  const { facilities } = useSelector(facilitiesSelector);
  const { departments } = useSelector(departmentsSelector);


  const filteredLanguages = React.useMemo(() =>
    languages?.map(language => {
      const object = {
        value: language.id,
        label: language.name
      }
      return object
    }), [languages]);


  const filteredFacilities = React.useMemo(() =>
    facilities?.map(facility => {
      const object = {
        value: facility.id,
        label: facility.abbreviation
      }
      return object
    }), [facilities]);


  const filteredDepartments = React.useMemo(() =>
    departments?.map(department => {
      const object = {
        value: department.id,
        label: department.name
      }
      return object
    }), [departments]);



  return (
    <>
      <div className='step_cards step_4'>
        <h2>Language / Facility / Department</h2>

        <div className="row-primary">
          <h2>Language <span style={{ color: 'red' }}>*</span></h2>
          <Controller
            name="language_id"
            control={control}
            rules={{
              required: "Please select a language"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="language_id"
                  options={filteredLanguages || []}
                  {...field}
                  value={field.value ? filteredLanguages?.find((opt) => field.value == opt.value) : ""}

                />
                {
                  errors?.language_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.language_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>Facility <span style={{ color: 'red' }}>*</span></h2>
          <Controller
            name="facility_id"
            control={control}
            rules={{
              required: "Please select a facility",
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="facility_id"
                  options={filteredFacilities || []}
                  {...field}
                  value={field.value ? filteredFacilities?.find((opt) => field.value == opt.value) : ""}

                />
                {
                  errors?.facility_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.facility_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>Department <span style={{ color: 'red' }}>*</span></h2>
          <Controller
            name="department_id"
            control={control}
            rules={{
              required: "Please select a department",
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  name="department_id"
                  options={filteredDepartments || []}
                  {...field}
                  value={field.value ? filteredDepartments?.find((opt) => field.value == opt.value) : ""}

                />
                {
                  errors?.department_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.department_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>
      </div>
    </>
  )
}

const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'nonbinary', label: 'Nonbinary' },
]


const Card5_5 = ({
  control,
  watch,
  setValue,
  getValues,
  errors
}) => {

  return (
    <>
      <div className='step_cards step_5'>
        {/* <h2>Required Data</h2> */}
        <div className='w-100'>
          {/* <hr /> */}

          <div className="row-primary">
            <h2>Requester Full Name</h2>
            <Controller
              name="requester_name"
              control={control}
              render={({ field }) => <input className="input-in type_inp" type="text" name='requester_name' placeholder='Requester Full Name'  {...field} />}
            />
          </div>



          <div className="row-primary">
            <h2>Caller Phone Number</h2>

            <Controller
              name="caller_phone"
              control={control}
              render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='caller_phone' placeholder='Caller Phone number'  {...field} />}
            />
          </div>


          <div className="row-primary">
            <h2>Gender</h2>
            <Controller
              name="gender"
              control={control}
              render={({ field }) =>
                <div style={{ width: "100%" }}>
                  <Select
                    name="gender"
                    options={genderOptions || []}
                    {...field}
                    value={field.value ? genderOptions?.find((opt) => field.value == opt.value) : ""}

                  />
                </div>
              }
            />
          </div>



        </div>
      </div>
    </>
  )
}




const Card5 = ({ control, setValue, watch, dynamicFields, values, setValues }) => {


  return (
    <>
      <div className='step_cards step_5'>
        <h2>Required Data</h2>
        <div className='w-100'>
          <div className="">
            {values?.length > 0 &&
              values?.map((f, index) => (
                f?.name && (
                  <div key={index}>
                    <div className="row-primary">
                      <h2>{f.name}</h2>
                      <Controller
                        name={`dynamic_fields.${index}.value`} // Correctly map field name
                        control={control}
                        defaultValue={f.value || ""} // Set default value
                        render={({ field }) => (
                          <input
                            className="input-in type_inp"
                            type="text"
                            // placeholder={`Enter ${f.name}`}
                            {...field} // Spread field props
                            onChange={(e) => {
                              field.onChange(e.target.value); // Update hook form state

                              // Update the values state if you still need to maintain it
                              const updatedValues = [...values];
                              updatedValues[index] = {
                                ...updatedValues[index],
                                value: e.target.value,
                              };
                              console.log("updatedValues", updatedValues)
                              setValues(updatedValues); // Update local state
                            }}
                          />
                        )}
                      />
                    </div>
                  </div>
                )
              ))}
          </div>

          {/*   <hr /> */}
        </div>
      </div>
    </>
  )
}


const CopyAppointmentForm = ({ item, handleClose, callback, show, isDuplicate=false }) => {
  const dispatch = useDispatch();
  const [card5Values, setCard5Values] = useState([]);  //this is an array of values
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, setError: setErrors } = useForm({
    defaultValues: {
      language_id: "",
      facility_id: "",
      department_id: "",
      gender: "",
      caller_phone: "",
      requester_name: "",
      datetime: moment().format('YYYY-MM-DD HH:mm:ss'),
      subclient_id: "",
      dynamic_fields: [],
      type: DEFAULT_APPOINTMENT_TYPE

    }
  });
  const { error, loader } = useSelector(hospitalSelector);
  const { state: states } = useSelector(stateSelector);
  const { city: cities } = useSelector(citySelector);
  const [currentIndex, setCurrentIndex] = useState(0);




  const { dynamicFields } = useSelector(accountsSelector);

  // useEffect(() => {

  //   if (dynamicFields?.length > 0) {
  //     setValue("dynamic_fields", dynamicFields?.map(f => ({ name: f?.name, value: "" })))
  //   }

  // }, [dynamicFields])


  useEffect(() => {
    const subclient_id = watch("subclient_id");
        // subclient_id && dispatch(fetchSubClients(subclient_id))
  }, [watch("subclient_id")])


  useEffect(() => {

      // dispatch(fetchTypes(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
      // dispatch(fetchLanguages(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
      // dispatch(fetchFacilities(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
      // dispatch(fetchDepartments(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
      // dispatch(fetchAccounts(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }));

      // dispatch(fetchCitys(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
      // dispatch(fetchStates(1, { pageLength: 1000, sortBy: "id", sortDirection: "asc" }))
    setCurrentIndex(0)
    return () => {

      setCurrentIndex(0)
    }
  }, []);

  const resetAllFields = () => {

    dispatch(setError({}))
    setValue("type", DEFAULT_APPOINTMENT_TYPE);

    setValue("datetime", moment().format('YYYY-MM-DD HH:mm:ss'))

    setValue('requester_name', '');
    setValue('caller_phone', '');
    setValue('gender', '');



    setValue('subclient_id', '');
    setValue('name', '');
    setValue("department_id", '');
    setValue('language_id', '');
    setValue('facility_id', '');
    setValue('status', 1)
    setValue("city_id", '')
    setValue("state_id", '')
    setValue("dynamic_fields", [])
    setCurrentIndex(0)
  }

  useEffect(() => {


    return () => resetAllFields()
  }, [show])

  useEffect(() => {

    if (show && item?.id) {
      setValue("type", item?.type);
      setValue('subclient_id', item?.subclient_id);
      setValue('name', item?.name || '');
      setValue('datetime', moment(item?.datetime).format('YYYY-MM-DD HH:mm:ss'))
      setValue('department_id', item?.department_id || '')
      setValue('language_id', item?.language_id || '');
      setValue('facility_id', item?.facility_id || '');
      setValue('department_id', item?.department_id || '');
      setValue('requester_name', item?.requester_name || '');
      setValue('caller_phone', item?.caller_phone || '');
      setValue('gender', item?.gender || '');
      if (item?.dynamic_fields && typeof (item?.dynamic_fields) == "string")
        setValue("dynamic_fields", JSON.parse(item?.dynamic_fields) || [])
      setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)
      dispatch(setError({}))
    }
    return () => resetAllFields()

  }, [item, show])

  useEffect(() => {

    if (states?.length > 0) {
      if (item?.state_id)
        setValue("state_id", item?.state_id)
    }
    if (item?.city_id) setValue("city_id", item?.city_id)
  }, [item, cities, states]);


  useEffect(() => {
    if (!item?.dynamic_fields) {

      setCard5Values(
        dynamicFields?.map(f => ({ name: f?.name, value: "" }))
      )
    } else {
      const dynamic_fields = item?.dynamic_fields ? JSON.parse(item?.dynamic_fields) : []
      setCard5Values(dynamic_fields?.map(f => ({ name: f?.name, value: f?.value })))
    }
  }, [dynamicFields, item?.dynamic_fields])



  useEffect(() => {
    if (card5Values?.length > 0) {
      setValue("dynamic_fields", card5Values)
    }


  }, [card5Values])



  const submitCallback = (status, message) => {
    if (status) {
      // toast.success(message, {
        //className:"successToast",
      //})
      resetAllFields()
      callback&&callback()
     
      handleClose();
      Swal.fire({
        title: "Success!",
        text: message,
        icon: "success"
      });
      // dispatch(fetchAppointments());
    }
    else {
      console.log('onSubmit', error)
       toast.error(message,
        {
          className:"errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {

    dispatch(setError({}))
    if (item?.id && !isDuplicate) {
      dispatch(updateAppointment(data, item?.id, submitCallback));
    } else
      dispatch(addAppointment(data, submitCallback));
  }

  // Next button handler

  const requiredFields = [
    "subclient_id",
    "datetime"
  ]

  const handleNext = () => {
    if (currentIndex < cards.length - 1) {
      // setCurrentIndex(currentIndex + 1);
      handleSubmit(
        (data) => {

          for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              const element = data[key];
              if (cards[currentIndex]?.values?.includes(key)) {
                if (!element) {

                  setErrors(key, {
                    type: "required",
                    message: `This field is required`
                  })
                  return
                }
                else {
                  setErrors(key, null)
                }

              }

            }
          }
          setCurrentIndex(currentIndex + 1);

          // console.log("values]", data[cards[currentIndex].values])

          // if (!data[cards[currentIndex].values]) {
          //   setErrors("subclient_id", "Please select a client");
          //   return
          // }
          // else {
          //   setCurrentIndex(currentIndex + 1);
          // }

        },
        (error) => {
          console.log("Validation Errors:", error); // Error callback
        }
      )();
    }
  };

  // Previous button handler
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };



  const cards = [
    {
      id: 1, content: "Select a Client",
      component: <Card1 control={control} errors={errors} item={item} />,
      values: ["subclient_id"]
    },
    { id: 2, content: "Appointment Type", component: <Card2 control={control} name="type" errors={errors} /> },
    {
      id: 3, content: "Date & Time", component: <Card3 control={control} watch={watch} errors={errors} />,
      values: ["datetime"]
    },
    { id: 4, content: "Language / Facility / Department", component: <Card4 control={control} watch={watch} errors={errors} /> },

    { id: 5, content: "Required Data", component: <Card5_5 control={control} errors={errors} setValue={setValue} /> },
    { id: 6, content: "Required Data", component: <Card5 control={control} watch={watch} errors={errors} setValue={setValue} dynamicFields={dynamicFields} values={card5Values} setValues={setCard5Values} /> },
    {
      id: 7, content: "Confirm Data", component: <Card6 control={control} handleSubmit={handleSubmit(onSubmit)} item={item} watch={watch}
        onClose={handleClose}

      />
    },
  ];

  return (
    <div>
      <form >

        {cards[currentIndex].component}

      </form>

      <div className='row_shift Step_change'>
        {currentIndex > 0 && (
          <button type='button' onClick={handlePrev} className='main_button'>
            <img src="/images/arrow-right.png" alt />
          </button>
        )}

        {currentIndex < cards.length - 1 && (
          <button type='button' onClick={handleNext} className='main_button'>
            <img src="/images/arrow-left.png" alt="" style={{ filter: 'grayscale(1) brightness(5)' }} />
          </button>
        )}

        {currentIndex == cards.length - 1 &&
          <button type="button" className="main_button" onClick={resetAllFields}>

            {loader ?
              <>
                <Spinner size="sm">
                  Loading...
                </Spinner>

                <span>
                  {' '}Loading
                </span>
              </>
              :
              <span>
                {/* {item?.id ? "Update" : "Create"} */}
                Start Over
              </span>
            }
          </button>
        }
      </div>
    </div>
  )
}

const CopyAppointment = ({ item, onClose, callback, show }) => {
  const closeModalRef = useRef();

  return (
    <div className={`modal fade`} id="copyAppointmentPopUp" tabIndex="-1" aria-labelledby="copyAppointmentPopUpLabel" role="dialog">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content full_modal">
          <div className="modal-header header_modal align-items-center">
            <div></div>
            <h5 className="modal-title_u">Copy Appointment</h5>
            <button onClick={onClose} type="button" className="btn-close" ref={closeModalRef} data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body modal_form_body">
            {
              <CopyAppointmentForm 
              isDuplicate={true}
              item={item}
                handleClose={() => {
                  closeModalRef.current.click();
                  onClose();
                }}
                callback={() => {
                  callback &&  callback();
                  console.log("status")
                  closeModalRef.current.click();
                  onClose();

                }}
                show={show}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default CopyAppointment
